// Browser side of the language list: the `meta` of every copy file in
// lib/native/candidate/, in CANDIDATE_LANG_CODES order. Importing only `meta`
// lets the bundler drop the copy itself, so the language bar and the router
// stay small. The build scripts read the same folder in Node (generate-seo-heads.mjs).
import { CANDIDATE_LANG_CODES } from "./candidatePages.js";

/** @type {{ code: string, hreflang: string, nativeName: string, banner: string }[]} */
const metas = /** @type {any[]} */ (Object.values(import.meta.glob("./candidate/*.js", { eager: true, import: "meta" })));

export const CANDIDATE_META = CANDIDATE_LANG_CODES.map((code) => metas.find((m) => m.code === code)).filter(Boolean);
export const candidateMetaFor = (code) => CANDIDATE_META.find((m) => m.code === code);
